

export function setAccountsFrom(state, accounts_from) {
    state.accounts_from = accounts_from
}

export function setContacts(state, contacts) {
    console.log(contacts)
    state.contacts = contacts
}

export function setauxiliary_book(state, auxiliary_book) {
    state.auxiliary_book = auxiliary_book
}
export function setParams(state, params){
    state.params = params
}
export function setSubscriber(state, subscriber){
    state.subscriber = subscriber
}





// WEBPACK FOOTER //
// ./src/modules/auxiliary-book-contact/mutations.js